export interface CustomButtonProps {
  children?: React.ReactChild;
  style?: React.CSSProperties;
  className?: string;
  onClick?: (event: React.MouseEvent) => void;
  disabled?: boolean;
  color: CustomButtonColor;
  type: CustomButtonTypes;
}

export enum CustomButtonColor {
  DEFAULT = "default",
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum CustomButtonTypes {
  BUTTON = "button",
  RESET = "reset",
  SUBMIT = "submit",
}
